import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterBar = ({ searchQuery, onSearchChange, statusFilter, onStatusChange, sortBy, onSortChange, onClearFilters }) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'great', label: 'Great Condition' },
    { value: 'good', label: 'Good Condition' },
    { value: 'damaged', label: 'Damaged Condition' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' }
  ];

  const hasActiveFilters = searchQuery || statusFilter !== 'all' || sortBy !== 'newest';

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="md:col-span-2">
          <Input
            type="search"
            placeholder="Search by name or LIIN..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
          />
        </div>

        <Select
          options={statusOptions}
          value={statusFilter}
          onChange={onStatusChange}
          placeholder="Filter by status"
        />

        <Select
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
          placeholder="Sort by"
        />
      </div>
      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Filter" size={16} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground">Active filters applied</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
          >
            Clear Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterBar;